import React, { useState, useEffect } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import config from '../../config/Constant';
import { useSelector } from 'react-redux'
import { API_BASE_URL, getRequest, downloadFile } from '../../helpers/apiHandler';
import CustomAlert from '../../components/CustomAlert';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import IconDownload from '../../assets/SidebarIcons/icon-download.svg';

const SMSPriceList = () => {
  const { access_token } = useSelector((state) => state.auth.user)
  const [loadingData, setLoadingData] = useState(false);
  const [focus, setFocus] = useState(false);
  const [search, setSearch] = useState('');
  const [priceData, setPriceData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const dataPreparation = (keys, values) => {
    const finalResult = values.map((value) =>
      keys.reduce((obj, key, index) => ({ ...obj, [key.toLowerCase()]: value[index] }), {})
    );

    return finalResult;
  };

  const fetch_sms_price_list = () => {
    setLoadingData(true);
    const data = { headers: { Authorization: access_token.token } };
    getRequest('/payment/sms-price-list', data, (res) => {
      if (res.success) {

        const result = res.data;

        setPriceData(result);
        setSearchData(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching SMS Price List',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const onSearch = (evt) => {
    const { value } = evt.target;
    const filteredData = priceData.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(value);
    if (value) {
      setSearchData(filteredData);
    } else {
      setSearchData(priceData);
    }
  };

  const handleDownloadPriceList = () => {
    const url = `/payment/download-sms-price-list`;
    downloadFile({
      url: url,
      data: {},
      access_token: access_token,
      fileName: `sms-price-list.csv`,
    });
    setAlertState({
      message: 'SMS Price List has been downloaded successfully',
      show: true,
      variant: 'success',
    });
  };

  useEffect(() => {
    fetch_sms_price_list();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  const columns = [
    {
      name: 'Country',
      sortable: true,
      selector: (row) => row.name,
    },
    {
      name: 'USD',
      sortable: true,
      width: '250px',
      selector: (row) => row.usd,
    },
    {
      name: 'EUR',
      sortable: true,
      width: '250px',
      selector: (row) => row.eur,
    },
    {
      name: 'MYR',
      sortable: true,
      width: '250px',
      selector: (row) => row.myr,
    },
  ];

  return (
    <>
      <div className="SMSPriceList" style={{ padding: 30 }}>
        <div className="page-heading">
          <div className="container-left">
            <div className="page-title">SMS Price List</div>
          </div>
          <div className="container-right">
            <InputGroup className="datatable-search">
              <InputGroup.Append className={focus ? 'input-focus' : ''}>
                <InputGroup.Text>
                  <img alt="..." src={searchIcon} />
                </InputGroup.Text>
              </InputGroup.Append>
              <Form.Control
                placeholder="Search country.."
                name="search"
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                value={search}
                onChange={onSearch}
              />
            </InputGroup>
            <Button variant="primary" onClick={handleDownloadPriceList} style={{ minWidth: 160 }}>
              <img src={IconDownload} alt="..." style={{ marginRight: 8 }} />
              Download
            </Button>
          </div>
        </div>
        <CustomAlert
          message={alertState.message}
          show={alertState.show}
          variant={alertState.variant}
          closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
        />
        <DataTable
          columns={columns}
          data={searchData}
          className="custom-datatable"
          paginationComponentOptions={{
            rowsPerPageText: 'Items per page:',
          }}
          pagination
        />
      </div>
    </>
  );
};

export default SMSPriceList;
